<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>receipt</mat-icon>
      <span>Imprimir Recibos</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body">
    <p class="preview-hint no-print">
      Pré-visualização de {{ data.lancamentos.length }} recibo(s). Cada recibo será impresso em uma página
      separada.
    </p>

    <div class="recibos-print-container">
      @for (lancamento of data.lancamentos; track lancamento; let i = $index) {
      <div class="recibo-card">
        <!-- Recibo header -->
        <div class="recibo-header">
          <div class="recibo-emitente">
            <div class="recibo-titulo">RECIBO</div>
          </div>
          <div class="recibo-numero">Nº {{ lancamento.id }}</div>
        </div>

        <!-- Narrative body -->
        <div class="recibo-narrativa">
          @if (getNomePessoa(lancamento)) {
          <p>
            <strong>{{ lancamento.idNaturezaMovimentacao === NaturezaMovimentacaoEnum.Entrada ? 'Recebi(emos) de:' :
              'Paguei(amos) a:' }}</strong>
            {{ getNomeEDocumentoPessoa(lancamento) }}
          </p>
          }
          <p>
            a importância de <strong>{{ formatarValor(lancamento.valor) }}</strong>
            ({{ getValorPorExtenso(lancamento.valor) }})
          </p>
          <p>Referente a "{{ lancamento.historico }}"</p>
        </div>

        <!-- Footer -->
        <div class="recibo-assinatura-section">
          <span class="recibo-data-extenso">{{ dataEmissao | date: 'dd/MM/yyyy' }} — {{
            getDataPorExtenso(dataEmissao) }}.</span>
          <div class="assinatura-area">
            <div class="assinatura-linha"></div>
            <span class="assinatura-label">{{ nomeEmpresa }}</span>
            @if (cnpjEmpresaFormatado) {
            <span class="assinatura-label">CNPJ: {{ cnpjEmpresaFormatado }}</span>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon>
      Imprimir
    </button>
  </div>
</div>